const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Enhanced Security',
    desc: 'Military-grade encryption and real-time threat detection keep your data and identity protected at all times, on any network.',
    tag: 'Security',
    img: 'https://public.readdy.ai/ai/img_res/d68326173ac51078558d2b047f4aab9d.jpg',
  },
  {
    icon: 'ri-speed-line',
    title: 'Optimised Performance',
    desc: 'Our apps are engineered to be lightweight and efficient — zero battery drain, zero slowdowns, just seamless iOS performance.',
    tag: 'Performance',
    img: 'https://readdy.ai/api/search-image?query=abstract%20speed%20and%20performance%20concept%20with%20flowing%20light%20trails%20on%20soft%20warm%20cream%20background%2C%20minimalist%20flat%20illustration%2C%20amber%20and%20stone%20tones%2C%20clean%20modern%20tech%20aesthetic%2C%20no%20text%2C%20centered%20composition&width=400&height=220&seq=feat002&orientation=landscape',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'User Privacy',
    desc: 'We operate a strict zero-log policy. Your browsing habits, personal data, and device activity are never collected or shared.',
    tag: 'Privacy',
    img: 'https://readdy.ai/api/search-image?query=abstract%20privacy%20and%20anonymity%20concept%20with%20soft%20blurred%20shapes%20and%20gentle%20light%20on%20pale%20stone%20background%2C%20minimalist%20flat%20illustration%2C%20neutral%20tones%20with%20subtle%20warm%20highlights%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20centered%20composition&width=400&height=220&seq=feat003&orientation=landscape',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Native iOS Design',
    desc: 'Built from the ground up for iOS — every interaction feels natural, every screen feels at home on your iPhone or iPad.',
    tag: 'Design',
    img: 'https://readdy.ai/api/search-image?query=abstract%20iOS%20mobile%20interface%20concept%20with%20clean%20rounded%20shapes%20and%20soft%20gradients%20on%20light%20background%2C%20minimalist%20flat%20illustration%2C%20warm%20neutral%20tones%2C%20modern%20Apple%20design%20aesthetic%2C%20no%20text%2C%20centered%20composition&width=400&height=220&seq=feat004&orientation=landscape',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    desc: 'Our team continuously ships improvements, security patches, and new features — keeping your apps current with the latest iOS releases.',
    tag: 'Support',
    img: 'https://readdy.ai/api/search-image?query=abstract%20software%20update%20and%20refresh%20concept%20with%20circular%20arrows%20and%20flowing%20lines%20on%20soft%20light%20background%2C%20minimalist%20flat%20illustration%2C%20cool%20stone%20and%20teal%20tones%2C%20clean%20modern%20tech%20aesthetic%2C%20no%20text%2C%20centered%20composition&width=400&height=220&seq=feat005&orientation=landscape',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    desc: 'Our expert support team is always available to help — whether you have a technical question or need guidance getting started.',
    tag: 'Support',
    img: 'https://readdy.ai/api/search-image?query=abstract%20customer%20support%20and%20communication%20concept%20with%20soft%20speech%20bubble%20shapes%20on%20warm%20light%20background%2C%20minimalist%20flat%20illustration%2C%20warm%20neutral%20and%20amber%20tones%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20centered%20composition&width=400&height=220&seq=feat006&orientation=landscape',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 md:py-36 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-stone-400 mb-4">
            <span className="w-4 h-px bg-stone-300" />
            Key Features
            <span className="w-4 h-px bg-stone-300" />
          </span>
          <h2 className="text-3xl md:text-5xl font-thin text-stone-900 leading-tight">
            Everything You Need<br />
            <em className="not-italic font-light text-stone-400">in One Ecosystem</em>
          </h2>
          <p className="mt-6 text-stone-500 text-base max-w-xl mx-auto leading-relaxed">
            Our products are designed to work together seamlessly, giving you complete control over your iOS device's security and performance.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-white rounded-2xl overflow-hidden flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              {/* Image area */}
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={feat.img}
                  alt={feat.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Content */}
              <div className="p-6 flex flex-col gap-3 flex-1">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-stone-100">
                    <i className={`${feat.icon} text-stone-600 text-base`} />
                  </div>
                  <span className="text-xs text-stone-400 uppercase tracking-widest font-medium">{feat.tag}</span>
                </div>
                <h3 className="text-base font-semibold text-stone-900">{feat.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
